import * as z from 'zod';

// Route keys that can be used for permissions - moved here to avoid circular dependencies
export const permissibleRouteKeys = z.enum([
  'dashboard',
  'team-member',
  'client',
  'contact',
  'competitor',
  'domain',
  'product',
  'agreement',
  'inventory',
  'pick-ticket',
  'governance',
  'recruiting',
  'marketing-campaign',
  'conference-event',
  'financial-snapshot',
  'award',
  'user',
  'support',
  'settings',
  'api-integration',
  'invoice',
  'account-receivables',
  'deposit',
]);

export type PermissibleRouteKeys = z.infer<typeof permissibleRouteKeys>;
